import "bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../scss/main.scss";

document.addEventListener("DOMContentLoaded", () => {
  const yearEl = document.getElementById("year");
  if (yearEl) {
    yearEl.textContent = String(new Date().getFullYear());
  }
});
